module.exports = __webpack_public_path__ + "img/AGR-A-1-III.c599ba11.png";